import React, { Fragment } from "react";
import { FormattedMessage } from 'react-intl';
import { Field } from "formik";
import {
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import Select2 from "react-select2-wrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as fontAwesome from "@fortawesome/free-solid-svg-icons";
import { ErrorMessage } from 'formik';
import { Messages } from '../layout/Messages/Messages';

function UserSelect(props) {
  const { users } = props;

  let formattedUser = users.map( item => {
    return { id: item.id, text: `${item.first_name} ${item.last_name}` }
  } );

  return (
    <FormGroup>
      <InputGroup
        className={`input-group-merge input-group-alternative select-addon select-input-user-for-payment ${props.getErrorClass( props.formikProps, 'userForPayment' )}`}>
        <FormattedMessage id={props.label}>
          {
            placeholder => (
              <Field>
                {
                  () => (
                    <Fragment>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          {
                            props.fontAwesome ?
                              <FontAwesomeIcon
                                icon={fontAwesome[props.fontAwesome]}/> :
                              <i className={props.icon}/>
                          }
                        </InputGroupText>
                      </InputGroupAddon>
                      <Select2
                        id='input-user-for-payment'
                        name={props.name}
                        defaultValue={props.value}
                        placeholder={placeholder[0]}
                        className='form-control'
                        options={{
                          placeholder: placeholder[0],
                        }}
                        data={formattedUser}
                        onChange={
                          event => {
                            if (props.onChange) {
                              props.onChange( event );
                            }
                          }
                        }
                      />
                    </Fragment>
                  )
                }
              </Field>
            )
          }
        </FormattedMessage>
      </InputGroup>
      <Messages
        color="danger"
        formikProps={props.formikProps}
        class="small-field-error"
        showDismiss={false}
      >
        <ErrorMessage
          name="userForPayment"
          component="div"
          data-testid="errors-userForPayment"
          className="field-error"
        />
      </Messages>
    </FormGroup>
  );
}

export { UserSelect };
